import { useContext } from 'react'
import { LocalisationContext } from 'providers/LocalisationProvider'

export default function Mission() {
  const _localisationService = useContext(LocalisationContext)

  function renderSubheadedPair(key) {
    const splitContent = _localisationService
      .getString(`${key}_content`)
      .split('\n')
    const splitSpans = splitContent.map((text, i) => <p key={i}>{text}</p>)

    return (
      <>
        <div className='about-section-img-container'>
          <img src={`/about/${key}.svg`} alt={`${key}`} />
        </div>
        <div className='about-section-text-container'>
          <h3 className='about-sub-heading'>
            {_localisationService.getString(`${key}_title`)}
          </h3>
          {splitSpans}
        </div>
      </>
    )
  }

  return (
    <div className='about'>
      <div className='about-section'>
        {renderSubheadedPair('about_supporting_relationships')}
      </div>
      <div className='about-section'>
        {renderSubheadedPair('about_supporting_wellbeing')}
      </div>
      <div className='about-section'>
        {renderSubheadedPair(
          'about_supporting_learners_with_additional_needs'
        )}
      </div>
      <div className='about-section'>
        {renderSubheadedPair('about_supporting_every_learner')}
      </div>
    </div>
  )
}
